import { RoleListI } from 'interfaces/Role';
import { create } from 'zustand';

interface StoreRolesProps {
  role: RoleListI | null;
  setRole: (role: RoleListI | null) => void;
  isEdit: boolean;
  setIsEdit: (state: boolean) => void;
  idRoleEdit: number;
  setIdRoleEdit: (id: number) => void;

  isOpenModalRole: boolean;
  handleOpenModalRole: () => void;
  handleCloseModalRole: () => void;
}

export const useRoleStore = create<StoreRolesProps>((set, get) => ({
  role: null,
  isEdit: false,
  idRoleEdit: 0,
  setRole: (rolepuseParam: RoleListI | null) => {
      set({ role: rolepuseParam });
    },
    setIsEdit: (state: boolean) => {
      set({ isEdit: state });
    },
    setIdRoleEdit: (id: number) => {
      set({ idRoleEdit: id });
    },
    isOpenModalRole: false,
    handleOpenModalRole: () => {
      set((state) => ({
        ...state,
        isOpenModalRole: !state.isOpenModalRole,
      }));
    },
    handleCloseModalRole: () => {
      set((state) => ({ ...state, isOpenModalRole: false }));
    },
}));
